import {
  INTERNAL_MESSAGE_TYPE,
  logRejectedPostMessage,
  validateCustomizerMessageEvent
} from "@/utils/customizerMessagingSecurity";

const IFRAME_SIGNALER_TYPE = INTERNAL_MESSAGE_TYPE;

export default function ({ $eventBus }) {
  /**
   * adds listener for parent or iframe emitters
   */
  window.addEventListener('message', function(event) {
    const validation = validateCustomizerMessageEvent(event);

    if (!validation.valid) {
      if (validation.reason !== "internal-message-type") {
        logRejectedPostMessage(validation);
      }
      return;
    }

    const { origin, source, command, body } = validation.message;
    // in emit we send body if exists and source if requires a response
    $eventBus.$emit(command, { origin, source, body });
  }, false);

  return {
    install(Vue) {
      Vue.prototype.$iframeCommunicator = {
        /**
         * @function postMessage
         * @param {Any} data - Data message to send
         * Proposal of structure:
         * Object: {
         *   type: IFRAME_SIGNALER_TYPE, // Should be a unique type per app
         *   command: 'toggleHeaders',
         *   body: {
         *     sku: 'some sku',
         *     recipe: 'some recipe'
         *   }
         * }
         * @param {String|HTMLIframeElement} target - Element to send the message.
         * NOTES:
         * - If null, will send to parent window
         * - If string, should be iframe ID
         * - If HTMLElement, should be the iframe element contentWindow
         * @param {String} domain - Domain to send the message
         * @returns {Void}
         * Send Message to window element target
         */
        postMessage(data = null, target = null, domain = '*') {
          let element = window.parent; // By default element should be the parent

          if (typeof target === 'string') { // Get element if target is String (ID)
            const domElement = document.getElementById(target);

            if (domElement && domElement.contentWindow) {
              element = domElement.contentWindow;
            } else {
              element = null;
            }
          } else if (target && target.postMessage instanceof Function) { // Get element if target is Iframe Element
            element = target;
          }

          if (!element) {
            console.error(`iframeCommunicator: Element to send message was not found by target provided.`);
            return;
          }
          if (!data) {
            console.error(`iframeCommunicator: data to send message was not defined.`);
            return;
          }

          element.postMessage({ type: IFRAME_SIGNALER_TYPE, ...data }, domain);
        }
      };
    }
  };
}
